import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalVariables } from 'src/app/data/global-variables';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';

  const file_login_desktop_prescriber = 'assets/welcomePageResources/login_desktop_prescriber.html';
  const file_login_mobile_prescriber = 'assets/welcomePageResources/login_mobile_prescriber.html';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  html_desktop!: SafeHtml;
  html_mobile!: SafeHtml;


  constructor(
    private authService: AuthService,
    private alertService: AlertService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    public globalVariables: GlobalVariables,
    private router: Router) {}

  ngOnInit(): void {


    this.http.get<string>(file_login_desktop_prescriber, { responseType: 'string' as 'json' }).subscribe(
      next => {
        this.html_desktop = this.sanitizer.bypassSecurityTrustHtml(next);
      },
      error => {
        console.error('ERROR', error);
      });

    this.http.get<string>(file_login_mobile_prescriber, { responseType: 'string' as 'json' }).subscribe(
      next => {
        this.html_mobile = this.sanitizer.bypassSecurityTrustHtml(next);
      },
      error => {
        console.error('ERROR', error);
      });


    // SCRIPTS QUE SON LLAMADOS DESDE EL HTML
    let script = this._renderer2.createElement('script');
    script.type = `text/javascript`;
    script.text = `
          function sendLogin() {
            const event = new CustomEvent("login");
            document.dispatchEvent(event);
          }
        `;

    this._renderer2.appendChild(this._document.body, script);

    document.addEventListener("login", (evt: Event) => {
      this.sendLogin();
    })
  }

  sendLogin(): Promise<void> {

    return new Promise<void>((resolve, reject) => {

      let userName: string = '';
      let password: string = '';
      try {
        userName = document.forms["loginForm"]["usuario"]?.value?.trim();
        password = document.forms["loginForm"]["contrasena"]?.value?.trim();
      } catch (error) {
        console.error(error);
        reject(error);
      }

      if (userName == undefined || userName == '') {
        alert(`Debe introducir un nombre de usuario`);
        reject('no userName');
      }
      if (password == undefined || password == '') {
        alert(`Debe introducir una contraseña`);
        reject('no password');
      }
  
     // this.spinnerService.show();
      this.authService.login(userName, password).then(res => {
        //this.spinnerService.hide();
  
        try {
  
          //console.log('res: ', res);
          res = JSON.parse(res as any);
  
          const grantAccess = (tkn: string): void => {
            localStorage.setItem('DBAuthTkn', tkn);  // ✅ Guardar token con el mismo nombre que el interceptor
            // Forzar la recarga del usuario para que se actualice con el nuevo token
            this.authService.forceReloadUser().then(() => {
              this.router.navigate(["/bookList"]); 
            });
          }
  
          if (res.message != null) {
            //this.alertService.alert(res.message, { func: grantAccess, arg: res.tkn });

          } else {
            grantAccess(res.tkn);
          }
        } catch (error) {
          
          //this.spinnerService.hide();
          this.alertService.alert('Ha ocurrido un error de conexión. Por favor, inténtelo de nuevo más tarde');
        }
  
  
      }).catch(err => {
        //this.spinnerService.hide();
        console.error(err);
        try {
          const st = JSON.parse(err.error)
          this.alertService.alert(st.message)
        } catch {
          this.alertService.alert('Ha ocurrido un error de conexión. Por favor, inténtelo de nuevo más tarde');
        }
        if (err?.error?.message == null) {
        } else {
          this.alertService.alert(err.error.message)
        }
      })
    });

  }


}
